import { zapiPlayOptions } from './utils';
import { errorPlayerContainerNotCreated } from './errors';
export const playerPlayProgram = (container, parameters) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getPlayerZapi();
    return player.playProgram(parameters.cid, parameters.programId, zapiPlayOptions(parameters.options));
};
